import FilePreviewModal from "@/common/modal/FilePreviewModal";
import Button from "@/common/ui/Button";
import { RoundLoader } from "@/common/ui/Loader";
import { PermissionDenied } from "@/common/ui/page/PermissionDeniedPage";
import { SideBarContentHeader } from "@/common/ui/SideBar";
import { InfoText } from "@/common/ui/Text";
import EmptyList from "@/components/common/EmptyList";
import DocumentViewCard from "@/components/dashboard/setting/documents/DocumentViewCard";
import AddDocumentModal from "@/components/dashboard/setting/documents/modal/AddDocumentsModal";
import UpdateDocumentModal from "@/components/dashboard/setting/documents/modal/UpdateDocumentModal";
import { ModalConfig, withModal } from "@/provider/withModalProvider";
import { useDocumentsInfo } from "@/services/common/profile.services";
import { pageEventSelector } from "@/store/features/dashboardSlice";
import { loginSelector } from "@/store/features/loginSlice";
import { PERMISSIONS } from "@/utils/constant/global.constant";
import { isHasPermission } from "@/utils/helper/permissions";
// import { loginSelector } from "@/store/features/loginSlice";
// import { useApprovalStatus } from "@/utils/helper/sseClient";
import { PlusCircle } from "lucide-react";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
// import { useSelector } from "react-redux";

const modalConfig: ModalConfig = {
  addDocument: {
    component: AddDocumentModal,
    title: "Upload verification document",
    type: "side",
    showCloseWarning: true,
  },
  updateDocument: {
    component: UpdateDocumentModal,
    title: "Update verification document",
    type: "side",
    showCloseWarning: true,
  },
  filePreview: {
    component: FilePreviewModal,
    title: "Preview",
    type: "full",
    asChild: true,
  },
};

interface DocumentPageProps {
  openModal: (modalKey: string, props?: any) => void;
  activeModal: string;
}

const DocumentsPage: React.FC<DocumentPageProps> = ({ openModal, activeModal }) => {
  const { data, refetch, isLoading }: any = useDocumentsInfo();
  const { currentUser } = useSelector(loginSelector);

  const pageEvent = useSelector(pageEventSelector);
  // const { currentOrg } = useSelector(loginSelector);

  const handleOpenModal = () => {
    openModal("addDocument", {
      uploadedDocs: data?.docs?.map((d: any) => d?.doc?.documentKey),
    });
  };

  useEffect(() => {
    if (!activeModal) {
      refetch();
    }
  }, [activeModal]);

  useEffect(() => {
    if (pageEvent?.keys.includes("documents") && pageEvent?.type === "refresh") {
      refetch();
    }
  }, [pageEvent]);

  if (!isHasPermission(currentUser?.perms, PERMISSIONS.SETTING["View Documents"])) {
    return <PermissionDenied />;
  }

  if (isLoading) return <RoundLoader />;

  return (
    <div className="px-2 md:px-4 flex flex-col flex-1 h-full">
      <SideBarContentHeader heading="Verification documents">
        {data?.docs.length < 4 && data?.docs.length > 0 && (
          <Button
            variant="primary"
            size="small"
            disabled={!isHasPermission(currentUser?.perms, PERMISSIONS.SETTING["Create Documents"])}
            onClick={handleOpenModal}
          >
            Upload document
          </Button>
        )}
      </SideBarContentHeader>
      {data?.docs.length > 0 ? (
        <div className=" flex flex-wrap gap-x-4 gap-y-5 py-4">
          {data.docs.map((doc: any, i: number) => (
            <DocumentViewCard key={i} documentInfo={doc} openModal={openModal} />
          ))}
        </div>
      ) : (
        <>
          <InfoText text="To unlock all features, please upload a valid document to verify your organization." className="mt-4" />
          <EmptyList
            text="No documents yet"
            icon="/icons/document.svg"
            className=" h-full gap-y-4"
            description="Please upload at least one document to verify your organization"
          >
            <Button
              variant="primary"
              size="small"
              onClick={handleOpenModal}
              disabled={!isHasPermission(currentUser?.perms, PERMISSIONS.SETTING["Create Documents"])}
              leftIcon={<PlusCircle className=" size-4" />}
            >
              Add document
            </Button>
          </EmptyList>
        </>
      )}
    </div>
  );
};

export const DocumentsPageWithModal = withModal(DocumentsPage, modalConfig);
